<div class="container-fluid" [class.disabled]="_showAccountAndSiteSelection">
  <div class="col-12 main_container">
    <div class="loginContainer">
      @if (!_verificationCodeMode) {
        <form [formGroup]="_form" class="form_center">
          <div class="imagoLogin"><img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud NG" /></div>
          <h2 class="loginProjectTitle">Welcome to BarCloud NG</h2>
          <small hidden>V24.00</small>
          <div class="form-group">
            <label class="loginInputLabel" for="loginEmail">Email Address</label>
            <input type="text" id="loginEmail" formControlName="email" class="form-control"
              placeholder="Enter Your Email Address" [ngClass]="{ 'is-invalid': submitted && form.email.errors }" />
            </div>
            <div class="form-group">
              <label class="loginInputLabel" for="loginPassword">Password</label>
              <div class="password-field-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" id="loginPassword" formControlName="password" class="form-control"
                  placeholder="Enter Your Password" [ngClass]="{ 'is-invalid': submitted && form.password.errors }" />
                  <button type="button" class="password-toggle-btn" (click)="togglePasswordVisibility()">
                    {{ showPassword ? 'Hide' : 'Show' }}
                  </button>
                </div>
              </div>
              <div class="forgotPasswordRow">
                <a (click)="_navigate('forgot-password')" class="forgotPasswordLink">Forgot My Password</a>
              </div>
              <div class="form-group loginButtonRow">
                <button (click)="onSubmit()" class="btn btn-primary loginBtn">
                  Login
                </button>
              </div>
              @if (error) {
                <div class="identity-invalid-feedback">
                  <div>{{error}}</div>
                </div>
              }
            </form>
          }

          @if (_verificationCodeMode) {
            <div class="form_center">
              <div class="imagoLogin"><img src="/assets/menu/enterprise/logo-enterprise.svg" alt="BarCloud NG" /></div>
              <h2 class="loginProjectTitle">Verify your code</h2>
              <div class="form-group">
                <label class="loginInputLabel" for="verificationCode">Verification code</label>
                <input id="verificationCode" [(ngModel)]="_code" class="form-control" placeholder="Enter the verification code" />
              </div>
              <div class="borderSeparetor verificationSeperator"></div>
              <div class="emailVerificationText">* A code has been sent to your email inbox</div>
              <div class="form-group loginButtonRow">
                <button (click)="onSubmitVerificationcode()" class="btn btn-primary loginBtn">
                  <span><img class="loginIcons" src="/assets/menu/enterprise/verify-code-icon.svg" /></span>
                  Verify Code
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <div id="footer" class="asap-auth">
        <div id="sub_footer" class="aa-footer-wrap">
          <div id="footr" class="aa-footer-bar">
            <p id="copyRight" class="aa-copy">Copyright © {{currentYear}}, ASAP Systems</p>

            <nav class="aa-footer-nav">
              <!-- <a [href]="footerUrls.releaseNoteUrl" target="_blank" rel="noopener noreferrer">Release Note</a> -->
              <a [href]="footerUrls.contactUsUrl" target="_blank" rel="noopener noreferrer">Contact Us</a>
              <!-- <a [href]="footerUrls.companyUrl" target="_blank" rel="noopener noreferrer">Company</a> -->
              <a [href]="footerUrls.returnPolicyUrl" target="_blank" rel="noopener noreferrer">Return Policy</a>
              <a [href]="footerUrls.privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <a [href]="footerUrls.termsOfServiceUrl" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            </nav>
          </div>
        </div>
      </div>
    </div>



    @if (_showAccountAndSiteSelection) {
      <account-site-popup [resolver]="_getAccounts" (onClose)="_closeAccountAndSiteWindow()"
        [returnUrl]="returnUrl">
      </account-site-popup>
    }

    @if (_agreementRequired) {
      <legal-agreement
        [submitting]="_agreementSubmitting"
        (accepted)="acceptAgreement()"
        (cancelled)="cancelAgreement()">
      </legal-agreement>
    }

    <!-- <kendo-window *ngIf="_showAccountAndSiteSelection" title="{{'Select Account and Site'}}"
    (close)="_closeAccountAndSiteWindow()" [resizable]="true" [draggable]="false">
    <asap-grid-layout [selectable]="true" [selectedKeys]="_selectedAccounts" [pagingEnabled]="false" [singleSelect]="true"
      [selectByField]="'id'" [selectByFieldTitle]="'Select Account'" [enableSiteSelection]="true" [filteringEnable]="true"
      [resolver]="_getAccounts" (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
      <ng-template pageListColumn name="Account Name" field="name" let-item>
        {{item.name}}
      </ng-template>
    </asap-grid-layout>

    <div class="form-group centerDisplay mb-3">
      <button (click)="onSubmit()" [disabled]="loading" class="btn btn-primary commonBouttonStyle loginBtn">
        <span><img class="loginIcons" src="/assets/menu/enterprise/login-icon.svg" /></span>
        Login
      </button>
    </div>
  </kendo-window> -->
